import Vue from "vue";
import VCharts from "v-charts";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
/**http请求封装 */
import Http from "./plugins/http";
/**显示信息封装 */
import Message from "./plugins/message";
// import "../theme/index.css";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/styles/reset.css";

import Menu from "./components/layout/menu.vue";
import CopyRight from "./components/layout/copyright.vue";

import urlMapping from "./plugins/httpUrlConfig";
import moment from "moment";
import { isNumber } from "util";
import Print from "vue-print-nb";
// import { U } from "core-js/modules/_export";
// import Cookies from "js-cookie";

console.log("process.env.VUE_APP_ENV:" + process.env.VUE_APP_ENV);

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VCharts);
Vue.use(Print);

/**Http Axios 配置 */
Vue.use(Http, {
  baseUrl: ""
});
Vue.use(Message);

/**全局过滤器 */
Vue.filter("formatDateTime", date => {
  if (moment(date).isBefore("2010-01-01")) {
    return "无";
  }
  return moment(date).format("YYYY-MM-DD HH:mm:ss");
});
Vue.filter("formatDateTimeSSS", date => {
  if (moment(date).isBefore("2010-01-01")) {
    return "无";
  }
  return moment(date).format("YYYY-MM-DD HH:mm:ss.SSS");
});
Vue.filter("formatDate", date => {
  if (moment(date).isBefore("2010-01-01")) {
    return "无";
  }
  return moment(date).format("YYYY-MM-DD");
});
/**订单 */
//订单状态

Vue.prototype.$formatOrderStatusSimple = v => {
  let result = "";
  switch (v) {
    case -1:
      result = "异常";
      break;
    case 0:
      result = "初始下单";
      break;
    case 10:
      result = "已经支付";
      break;
    case 20:
      result = "订单取消";
      break;
    case 30:
      result = "申请退款";
      break;
    case 40:
      result = "申请退款通过";
      break;
    case 50:
      result = "申请被驳回";
      break;
    case 60:
      result = "退款成功";
      break;
    case 70:
      result = "退款异常";
      break;
    default:
      break;
  }
  return result;
};

Vue.prototype.$formatOrderStatus = v => {
  let result = "";
  switch (v) {
    case -1:
      result = '<span class="el-tag el-tag--warning el-tag--dark">异常</span>';
      break;
    case 0:
      result = '<span class="el-tag el-tag--info el-tag--dark">初始下单</span>';
      break;
    case 10:
      result =
        '<span class="el-tag el-tag--success el-tag--dark">已经支付</span>';
      break;
    case 20:
      result =
        '<span class="el-tag el-tag--danger el-tag--dark">订单取消</span>';
      break;
    case 30:
      result = '<span class="el-tag el-tag el-tag--light">申请退款</span>';
      break;
    case 40:
      result =
        '<span class="el-tag el-tag--success el-tag--light">申请退款通过</span>';
      break;
    case 50:
      result =
        '<span class="el-tag el-tag--warning el-tag--light">申请被驳回</span>';
      break;
    case 60:
      result =
        '<span class="el-tag el-tag--success el-tag--plain">退款成功</span>';
      break;
    case 70:
      result =
        '<span class="el-tag el-tag--danger el-tag--light">退款异常</span>';
      break;
    default:
      break;
  }
  return result;
};

Vue.prototype.$formatReceiptStatus = v => {
  let result = "";
  switch (v) {
    case 0:
      result = '<span class="el-tag el-tag--info el-tag--dark">申请开票</span>';
      break;
    case 1:
      result =
        '<span class="el-tag el-tag--success el-tag--dark">已经开票</span>';
      break;
    case 2:
      result = '<span class="el-tag el-tag--danger el-tag--dark">拒绝</span>';
      break;

    default:
      result =
        '<span class="el-tag el-tag--danger el-tag--dark">未知状态</span>';
      break;
  }
  return result;
};

/**机器 */
//机器状态
Vue.filter("formatMachineStatus", date => {
  let result = "";
  switch (date) {
    case 100:
      result = "初始下单";
      break;
    case 200:
      result = "已经支付";
      break;
    case 300:
      result = "订单取消";
      break;
    case 400:
      result = "退换钱款";
      break;
    default:
      result = "状态未知";
      break;
  }
  return result;
});
//机器类型formatMachineType
Vue.filter("formatMachineType", date => {
  let result = "";
  switch (date) {
    case 1:
      result = "上翻盖洗衣机";
      break;
    case 2:
      result = "前置翻盖洗衣机";
      break;
    case 9:
      result = "烘干机";
      break;
    default:
      result = "类型未知";
      break;
  }
  return result;
});
//金额
Vue.filter("formatPrice", price => {
  if (isNumber(price)) {
    return "￥" + price.toFixed(2);
  } else {
    return price;
  }
});

//HTTP Url 地址统一管理mapping
Vue.prototype.$urlMapping = urlMapping;

// Vue.prototype.$UTC = date => {
//   return moment(date).add(8, "hours");
// };

Vue.prototype.$ToDateString = x => {
  return moment(x).format("YYYY-MM-DD");
};

Vue.prototype.$ToDateTimeString = x => {
  return moment(x).format("YYYY-MM-DDTHH:mm:ss");
};

//传入（label值和数组list），如果list中的某个对象的label===传入的label值，则返回这个对象的value，否则返回label
Vue.prototype.$getValueByLabel = (label, list) => {
  let element = list.find(ele => ele.label === label);
  if (element !== undefined) {
    return element.value;
  } else {
    return label;
  }
};

//传入（label值和数组list），如果list中的某个对象的value===传入的value值，则返回这个对象的label，否则返回value
Vue.prototype.$getLabelByValue = (value, list) => {
  let element = list.find(
    ele => ele.value === value || parseInt(ele.value) === value
  );
  if (element !== undefined) {
    return element.label;
  } else {
    return "未知【" + value + "】";
  }
};

Vue.prototype.fromHistogramToPie = (label1, label2, values) => {
  if (!values.columns) {
    return;
  }
  let columns = [label1, label2];
  let rows = [];
  let originColumns = [...values.columns];
  originColumns.splice(0, 1);
  originColumns.forEach(ele => {
    rows.push({
      [label1]: ele,
      [label2]: values.rows.reduce((total, currentValue) => {
        return total + Number(currentValue[ele]);
      }, 0)
    });
  });
  return {
    columns,
    rows
  };
};

Vue.prototype.fromHistogramToPieForHours = values => {
  if (!values.columns) {
    return;
  }
  let columns = ["日期", "数量"];
  let rows = [];
  values.rows.forEach(ele => {
    let count = 0;
    for (const key in ele) {
      if (ele.hasOwnProperty(key) && key !== "日期") {
        count += Number(ele[key]);
      }
    }
    rows.push({
      ["日期"]: parseInt(ele["日期"]) + "时",
      ["数量"]: count
    });
  });
  return {
    columns,
    rows
  };
};

Vue.prototype.$queryAgentForPrompt = function(callback) {
  return this.$axios(this.$urlMapping["查询代理商提示"], {
    data: {}
  }).then(result => {
    //console.log(result);
    callback(result);
  });
};

Vue.prototype.$queryVendorForPrompt = function(agentid, callback) {
  return this.$axios(this.$urlMapping["查询加盟商提示"], {
    data: { agentid: agentid }
  }).then(result => {
    //console.log(result);
    callback(result);
  });
};

Vue.prototype.$queryShopForPrompt = function(vendorid, callback) {
  return this.$axios(this.$urlMapping["查询门店提示"], {
    data: { shopOwner: vendorid }
  }).then(result => {
    //console.log(result);
    callback(result);
  });
};

Vue.prototype.$createFilter = function(queryString) {
  return x => {
    return x.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0;
  };
};

Vue.prototype.$getAgentID = function(agentName) {
  if (!this.$AllAgentIDName) {
    this.$message.error("基础数据缺失，请刷新页面重试");
    return "";
  }
  let item = this.$AllAgentIDName.find(ele => ele.value === agentName);
  if (item) {
    return item.agentid;
  } else {
    return "";
  }
};

Vue.prototype.$getAgentName = function(agentid) {
  if (!this.$AllAgentIDName) {
    this.$message.error("基础数据缺失，请刷新页面重试");
    return "";
  }
  let item = this.$AllAgentIDName.find(ele => ele.agentid === agentid);
  if (item) {
    return item.value;
  } else {
    return "";
  }
};

Vue.prototype.$getVendorID = function(vendorName) {
  if (!this.$AllVendorIDName) {
    this.$message.error("基础数据缺失，请刷新页面重试");
    return "";
  }
  let item = this.$AllVendorIDName.find(ele => ele.value === vendorName);
  if (item) {
    return item.vendorid;
  } else {
    return "";
  }
};

Vue.prototype.$getVendorName = function(vendorid) {
  if (!this.$AllVendorIDName) {
    this.$message.error("基础数据缺失，请刷新页面重试");
    return "";
  }
  let item = this.$AllVendorIDName.find(ele => ele.vendorid === vendorid);
  if (item) {
    return item.value;
  } else {
    return "";
  }
};

Vue.prototype.$getShopID = function(shopName) {
  if (!this.$AllShopIDName) {
    this.$message.error("基础数据缺失，请刷新页面重试");
    return "";
  }
  let item = this.$AllShopIDName.find(ele => ele.value === shopName);
  if (item) {
    return item.shopid;
  } else {
    return "";
  }
};

Vue.prototype.$getShopName = function(shopid) {
  // console.log("Vue.prototype.$getShopName=", this.$AllShopIDName);

  if (!this.$AllShopIDName) {
    this.$message.error("基础数据缺失，请刷新页面重试");
    return "";
  }

  let item = this.$AllShopIDName.find(ele => ele.shopid === shopid);
  if (item) {
    return item.value;
  } else {
    //console.log("not found");
    return "";
  }
};

Vue.prototype.$getAllMachineModelInfoList = async function() {
  let result = await this.$axios(this.$urlMapping["查询机器联动"], {
    data: {}
  });
  Vue.prototype.$AllMachineModelInfoList = result;
  return result;
};

Vue.prototype.$getAllAgentIDName = async function() {
  let result = await this.$axios(this.$urlMapping["查询代理商IDName"], {
    data: {}
  });

  Vue.prototype.$AllAgentIDName = result;
  return result;
};

Vue.prototype.$getAllVendorIDName = async function() {
  //console.log("getAllVendorIDName");
  let result = await this.$axios(this.$urlMapping["查询加盟商IDName"], {
    data: {}
  });
  Vue.prototype.$AllVendorIDName = result;
  return result;
};

Vue.prototype.$getAllShopIDName = async function() {
  let result = await this.$axios(this.$urlMapping["查询门店IDName"], {
    data: {}
  });
  Vue.prototype.$AllShopIDName = result;
  return result;
};

export function initBasicData() {
  console.log("begin init");
  // sessionStorage.clear();
  Vue.prototype.$AllMachineModelInfoList = [];
  Vue.prototype.$AllAgentIDName = [];
  Vue.prototype.$AllVendorIDName = [];
  Vue.prototype.$AllShopIDName = [];

  Vue.prototype.$getAllMachineModelInfoList();
  Vue.prototype.$getAllAgentIDName();
  Vue.prototype.$getAllVendorIDName();
  Vue.prototype.$getAllShopIDName();
}

initBasicData();

Vue.prototype.$getToken = function() {
  //console.log("getAllShopIDName");
  let userInfo = localStorage.getItem("userInfo");
  if (userInfo) {
    return JSON.parse(userInfo).token;
  }
  return "";
};

Vue.prototype.$getUserType = function() {
  //console.log("getAllShopIDName");
  let userInfo = localStorage.getItem("userInfo");
  if (userInfo) {
    return JSON.parse(userInfo).user_type;
  }
  return "";
};

//全局组件注册器
Vue.component("Menu", Menu);
Vue.component("CopyRight", CopyRight);

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
